import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CHECKIN_ROUTES } from '@conf/routes.config';
import { CommonLibService } from '@lib/services';
import { CheckinBaseComponent } from '@common/components';
import { CheckinCommonStoreService } from '@common/services/checkin-common-store/checkin-common-store.service';
import { PREVIOUS_PAGE_IDENTIFIER } from '@conf/previous-page-identifier.config';

@Component({
  selector: 'asw-checkin-passenger-input-sub-header',
  templateUrl: './checkin-passenger-input-sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckinPassengerInputSubHeaderComponent extends CheckinBaseComponent {
  /** 戻り先URL */
  backUrl = '';

  constructor(_commonLibService: CommonLibService, private _checkinCommonStoreService: CheckinCommonStoreService) {
    super(_commonLibService);
  }

  override init(): void {
    const previousPageIdentifier = this._checkinCommonStoreService.checkinCommon.previousPageIdentifier;

    switch (previousPageIdentifier) {
      case PREVIOUS_PAGE_IDENTIFIER.CHECKIN_REVIEW:
        this.backUrl = CHECKIN_ROUTES.checkinReview;
        break;

      case PREVIOUS_PAGE_IDENTIFIER.CHECKIN_STATUS:
        this.backUrl = CHECKIN_ROUTES.checkinMybooking;
        break;
    }
  }

  override destroy(): void {}
  override reload(): void {}
}
